import { gql } from '@apollo/client'

export const COUPON = gql`
  mutation GetCoupon($coupon: String!) {
    getCoupon(coupon: $coupon)
  }
`